Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    searchFieldSearchButtonForegroundColorActive: tokens.themeForegroundInvertedDefault,
    searchFieldSearchButtonBackgroundColorActiveDefault: tokens.themeForegroundAccentDefault,
    searchFieldSearchButtonBackgroundColorActiveHover: tokens.themeForegroundAccentHover,
    searchFieldSearchButtonBackgroundColorActivePressed: tokens.themeForegroundAccentPressed,
    searchFieldSearchButtonBorderLeftWidth: 1,
    searchFieldSearchButtonBorderLeftRadius: 0,
    searchFieldSearchButtonBorderLeftColorDefault: tokens.themeBorderPrimaryDefault,
    searchFieldSearchButtonBorderLeftColorDisabled: tokens.themeBorderPrimaryDisabled,
    searchFieldSuggestionListBackgroundColor: tokens.themeBackgroundPrimaryDefault,
    searchFieldSuggestionListBorderWidth: 1,
    searchFieldSuggestionListBorderRadius: 4,
    searchFieldSuggestionListBorderColor: tokens.themeBorderPrimaryDefault,
    searchFieldSuggestionListFontWeightDefault: 400,
    searchFieldSuggestionListFontWeightMatched: 600,
    searchFieldSuggestionListFooterBorderWidth: 1,
    searchFieldSuggestionListFooterBorderRadius: 0,
    searchFieldSuggestionListFooterBorderColor: tokens.themeBorderPrimaryDefault,
    searchFieldSuggestionListFooterSpacingHorizontal: 16,
    searchFieldSuggestionListFooterSpacingVertical: 8,
    searchFieldSuggestionListHeaderFontSize: 12,
    searchFieldSuggestionListHeaderLineHeight: "16px",
    searchFieldSuggestionListHeaderSpacingHorizontal: 16,
    searchFieldSuggestionListHeaderSpacingVertical: 4,
    searchFieldSuggestionListHeaderBorderWidth: 1,
    searchFieldSuggestionListHeaderBorderRadius: 0,
    searchFieldSuggestionListHeaderBorderColor: tokens.themeBorderPrimaryDefault,
    searchFieldSuggestionListPopoverElevation: 70,
    searchFieldSuggestionListPopoverOffsetVertical: 4
  }
};